module.exports = __webpack_public_path__ + "img/newicon5.688fc67e.svg";